module.exports = __webpack_public_path__ + "img/niu3.47651a0c.jpg";